'use strict';

function Style() {
    /********************************/
    // Apply style
    /********************************/
    this.applyStyle = function () {
        if ($('#sitspagedatasection').length > 0) {
            $('#sitspagedatasection').find('table').each(function(){
                $(this).removeClass('sitstablegrid').addClass('table table-bordered table-hover table-striped');
                $(this).find('td').removeClass('sitstabledescriptioncell');
                $(this).find('th').removeClass('rowhead1');
            });
        }
        if ($('.am-date-selector').length > 0) {
            $('.am-date-selector').find('.splitdatelabel').each(function () {
                $(this).next('select').andSelf().wrapAll('<div class="form-group"/>');
            });
            $('.am-date-selector').find('.form-group').wrap('<div class="col-md-4"/>');
        }
    };
}
